// extracted by mini-css-extract-plugin
export default {"root":"src-views-debug-containers-DebugSnapView__root--uqdfk"};